import moment from "moment";
import { createDataPointProcessor } from "../utils/dataPointProcessor";
import { applyLineGraphState } from "../utils/lineGraphState";
import {
  initializeDictionaries,
  initializeEmotionDict,
  initializeActionDictionaries,
} from "../utils/dictionaries";
import { updateEmotions } from "./emotionHandler";
import {
  transform,
  transformActions,
  transformFilteredData,
  transformAllActions,
  transformStudentSupportData,
  computeParticipationPercentChange,
} from "../utils/transformers";
import {
  processSpecificClass,
  processSpecificStudent,
} from "../utils/processClasses";

export function handleStudent(state, student) {
  const { currentDict, compareDict } = initializeDictionaries();
  const { currentActionDict, compareActionDict } =
    initializeActionDictionaries();
  const currentParticipants = new Set();
  const compareParticipants = new Set();
  const emotionDict = initializeEmotionDict();
  let impactfulActions = { action: {}, emotion: {} };
  let newState = {};
  let filterDataPoints = [];
  let studentEmotionData = {};
  let studentSupportData = {};
  const bigFiveFilteredData = [];
  const lineGraphSourceData = [];
  const contextFilteredDataPoints = [];
  let tooltipCounts = initializeEmotionDict();
  const now = moment();
  const currentDate = moment().subtract(state.filterAmountCurrent);
  const compareDate = moment().subtract(
    state.filterAmountCurrent + state.filterAmountCompare
  );
  const allEmotions = state.multiEmotion?.emotions || [];

  const processDataPoint = createDataPointProcessor(
    currentDate,
    compareDate,
    now,
    state.chosenEmotion,
    currentDict,
    compareDict,
    currentActionDict,
    compareActionDict,
    impactfulActions,
    filterDataPoints,
    studentEmotionData,
    studentSupportData,
    bigFiveFilteredData,
    state.selectedTimes,
    state.selectedSubOptions,
    state.helpfulFilter,
    tooltipCounts,
    currentParticipants,
    compareParticipants,
    allEmotions,
    lineGraphSourceData
  );

  if (student === "All Students") {
    processSpecificClass(state, state.chosenClass, processDataPoint);
  } else {
    processSpecificStudent(state, student, processDataPoint);
  }

  newState.chosenStudent = student;
  newState.filteredDataPoints = filterDataPoints;
  newState.bigFiveFilteredData = bigFiveFilteredData.sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );
  applyLineGraphState(newState, lineGraphSourceData, state.chosenTime, now);
  newState.contextFilteredDataPoints = contextFilteredDataPoints;
  newState.tooltipCounts = tooltipCounts;
  transformStudentSupportData(
    studentSupportData,
    state.chosenPercentage,
    newState
  );

  updateEmotions(
    state.feeling,
    state.filterAmountCurrent,
    state.district,
    state,
    emotionDict,
    newState
  );

  transform(currentDict, compareDict, newState);
  transformActions(impactfulActions, newState);
  transformAllActions(currentActionDict, compareActionDict, newState);
  transformFilteredData(studentEmotionData, state.chosenPercentage, newState);
  computeParticipationPercentChange(
    currentParticipants,
    compareParticipants,
    newState
  );

  return newState;
}
